module.exports = __webpack_public_path__ + "img/icon_map_36_on_110.a31f1c5c.png";